var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawer-content",
};
const DrawerContent = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    const classList = classNames("tecma-drawer-content", className);
    return (_jsx("nav", Object.assign({ className: classList }, rest, { children: children })));
};
DrawerContent.defaultProps = defaultProps;
export default React.memo(DrawerContent);
